module.exports = __webpack_public_path__ + "static/media/bg-product-card.22a5feb1.png";